import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Layout, Form, Input, Select, Button, Steps, Typography, Row, Col, Spin, message, Modal } from 'antd';
import { RightOutlined, LeftOutlined, LockOutlined, MinusCircleFilled } from '@ant-design/icons';
import { fetchWithDeviceId } from './utils/deviceId';

const { Content } = Layout;
const { Option } = Select;
const { Step } = Steps;
const { Title, Text } = Typography;

// 辅助函数：延时 ms 毫秒
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// 自动解锁时长（单位：秒），例如 300 秒即 5 分钟
const AUTO_UNLOCK_DURATION = 300;

/* 新的 JarButton 组件，改为普通的 Button */
const JarButton = React.memo(({ jar, onClick, selected, myTel }) => {
  const isLocked = jar.locked === 1;
  const isMyLock = isLocked && (jar.locked_op_user === myTel);

  let buttonProps = {};
  if (selected) {
    buttonProps = {
      type: 'primary',
      style: { backgroundColor: '#1890ff', borderColor: '#1890ff' },
      disabled: false,
    };
  } else if (isLocked) {
    if (isMyLock) {

      buttonProps = {
        type: 'primary',
        style: { backgroundColor: 'green', borderColor: 'green', color: 'white' },
        disabled: true,
      };
    } else {
      console.info(jar.locked_op_user)
      console.info(myTel)
      console.info("isMyLock2")
      buttonProps = {

        type: 'default',
        style: { backgroundColor: 'gray', borderColor: 'gray' },
        disabled: true,
      };
    }
  } else {
    buttonProps = {
      type: 'default',
      disabled: false,
    };
  }

  return (
    <Button onClick={() => onClick(jar)} {...buttonProps}>
      {jar.jar_name}
    </Button>
  );
});

/* async function fetchWithDeviceId(url, options = {}) {
  const deviceId = getDeviceId();
  const headers = {
    'Content-Type': 'application/json',
    // 这里将设备 ID 放到请求头中，当然也可以选择放在请求参数中
    'X-Device-ID': deviceId,
    ...options.headers,
  };
  return fetch(url, { ...options, headers });
} */

/* 倒计时组件：根据 locked_time 和 AUTO_UNLOCK_DURATION 计算剩余秒数 */
function CountdownTimer({ lockedTime, autoUnlockDuration, onExpire }) {
  const [remaining, setRemaining] = useState(0);

  useEffect(() => {
    if (!lockedTime) return;
    function updateTimer() {
      const lockedDate = new Date(lockedTime);
      const now = new Date();
      const elapsed = Math.floor((now.getTime() - lockedDate.getTime()) / 1000);
      const rem = autoUnlockDuration - elapsed;
      setRemaining(rem > 0 ? rem : 0);
      if (rem <= 0 && onExpire) {
        onExpire();
      }
    }
    updateTimer();
    const interval = setInterval(updateTimer, 500);
    return () => clearInterval(interval);
  }, [lockedTime, autoUnlockDuration, onExpire]);

  return <Text type="danger">剩余解锁时间：{remaining} 秒</Text>;
}

/* 购物车单项卡片组件，显示酒阁、容量、酒坛及删除按钮 */
const CartItemCard = ({ item, onDelete }) => (
  <div style={{ border: '1px solid #ccc', padding: 8, borderRadius: 4, minWidth: '150px' }}>
    <div style={{ marginBottom: 8, textAlign: 'center' }}>
      <Button
        type="primary"
        disabled
        style={{
          width: '80px',
          height: '40px',
          backgroundColor: 'green',
          color: 'white',
          borderColor: 'green',
          cursor: 'default'
        }}
      >
        {item.jar_name}
      </Button>
    </div>
    <div>
      <div>
        <Text strong>酒阁: </Text>
        <Text>{item.jar_house}</Text>
      </div>
      <div>
        <Text strong>容量: </Text>
        <Text>{item.quantity}</Text>
      </div>
      <div>
        <Text strong>酒坛: </Text>
        <Text>{item.jar_name}</Text>
      </div>
      {item.locked === 1 && item.locked_time && (
        <CountdownTimer lockedTime={item.locked_time} autoUnlockDuration={AUTO_UNLOCK_DURATION} />
      )}
    </div>
    <Button size="small" type="link" onClick={onDelete}>删除</Button>
  </div>
);


/* 用户信息卡片组件，在确认页中展示 */
const UserInfoCard = ({ memberInfo, phone, iptData }) => (
  <div style={{
    border: '1px solid #eee',
    padding: 16,
    borderRadius: 8,
    textAlign: 'left',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
  }}>
    <Title level={3}>用户信息</Title>
    <div style={{ width: '160px', margin: '16px auto', padding: '8px', border: '1px solid #eee', borderRadius: 4, textAlign: 'center' }}>
      {!memberInfo.is_new && (
        <img src={memberInfo.head_img} alt="头像" style={{ width: 80, height: 80, borderRadius: '50%' }} />
      )}
      <div>
        <div>
          <Text strong>手机号: </Text>
          <Text>{phone}</Text>
        </div>
        {memberInfo.is_new ? (
          <> 
              <div>
                <Text strong style={{ color: 'blue' }}>新用户</Text>
              </div>
              <div>
                <Text strong>姓名: </Text>
                <Text>{iptData.ownerName}</Text>
              </div>
              <div>
                <Text strong>经办人: </Text>
                <Text>{iptData.agentName}</Text>
              </div>
          </>
         
        ) : (
          <>
            <div>
              <Text strong>姓名: </Text>
              <Text>{memberInfo.name}</Text>
            </div>
            <div>
              <Text strong>昵称: </Text>
              <Text>{memberInfo.nick_name}</Text>
            </div>
          </>
        )}
      </div>
    </div>
  </div>
);

// 使用环境变量配置 API 基础地址
const API_BASE = process.env.REACT_APP_API_BASE;
console.info("API_BASE =", API_BASE);

function App() {
  // 步骤：0-填写信息；1-确认提交；2-倒计时页面
  const [currentStep, setCurrentStep] = useState(0);
  const [form] = Form.useForm();
  const [formData, setFormData] = useState({
    phone: '',
    quantity: '', // 用户必须主动选择
    jarHouse: '', // 动态生成，
    ownerName: '', // 新增用户姓名
    agentName: '',// 新增经办人
  });
  const [jarList, setJarList] = useState([]);
  const [jarHouseOptions, setJarHouseOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [memberInfo, setMemberInfo] = useState(null);
  const [shoppingCart, setShoppingCart] = useState([]);
  const [selectedJar, setSelectedJar] = useState(null); // 临时选中的酒坛（未加入购物车）
  const [countdown, setCountdown] = useState(3);
  const pollingTimer = useRef(null);

  // 定义“下一步”按钮是否可点击的条件
  const nextStepEnabled =
    (memberInfo?.is_new?(formData.ownerName && formData.agentName):formData.phone) &&
    memberInfo &&
    formData.quantity &&
    formData.jarHouse &&
    shoppingCart.length > 0;

  // 查询会员信息
  const handleConfirmPhone = async (addNee) => {
    if (!formData.phone) {
      message.error('请输入手机号');
      return;
    }
    const phoneRegex = /^(?:\+?86)?1[3-9]\d{9}$/;
    if (!phoneRegex.test(formData.phone)) {
      message.error('请输入有效的手机号');
      setMemberInfo(null);
      return;
    }
    setLoading(true);
    const startTime = Date.now();
    try {
      const response = await fetchWithDeviceId(`${API_BASE}/api/member?tel=${formData.phone}`);
      if (response.ok) {
        const data = await response.json();
        await addUser(data);


      } else {
        if (response.status === 403) {
          const errorData = await response.json();
          message.error(errorData.error);
          setMemberInfo(null);
          return;
        }
        message.error('查询会员信息出错');
        setMemberInfo(null);
      }
    } catch (err) {
      console.error('查询会员信息出错', err);
      message.error('查询会员信息出错');
      setMemberInfo(null);
    } finally {
      const elapsed = Date.now() - startTime;
      if (elapsed < 300) {
        await delay(300 - elapsed);
      }
      setLoading(false);
    }
  };

  const addUser = async (data) => {
    if ((data && data.name) || (data && data.nick_name)) {
          console.log('查询到的会员信息：', data);
          setMemberInfo(data);
        } else {
          message.info('欢迎新会员:' + formData.phone);
          setMemberInfo({ is_new: true, tel: formData.phone, name: "", nick_name: "" });
        }
        // 如果用户已选择藏酒容量，则额外查询对应 volume 的酒坛，
        // 并将当前用户锁定但未确认的酒坛放入购物车
        console.info("formData.quantity")
        console.info(formData.quantity)

        const jarsResponse = await fetchWithDeviceId(`${API_BASE}/api/jarsbytel?tel=${formData.phone}`);
        if (jarsResponse.ok) {
          const jars = await jarsResponse.json();
          // 过滤出当前用户锁定且未确认的酒坛
          console.info("in jars")
          console.info(jars)
          const userLockedJars = jars.filter(jar => jar.locked === 1 && jar.locked_op_user === formData.phone);
          setShoppingCart(userLockedJars);
        }
  }

  useEffect(() => {
    async function checkDeviceAuthorization() {
      try {
        const response = await fetchWithDeviceId(`${process.env.REACT_APP_API_BASE}/api/test`);
        if (!response.ok) {
          // 如果返回 403，就认为设备未授权
          if (response.status === 403) {
            const data = await response.json();
            Modal.error({
              title: '设备未授权',
              content: data.error || '您的设备没有被授权访问，请联系管理员',
              onOk: () => {
                // 可以根据需要进行跳转或其他处理
              },
            });
          } else {
            message.error('检查设备授权失败');
          }
        }
      } catch (error) {
        console.error('检查设备授权出错：', error);
        message.error('检查设备授权出错');
      }
    }
    checkDeviceAuthorization();
  }, []);

  // 获取酒坛数据
  const fetchJars = async (queryalldata = false, withLoading = true) => {
    console.info("fetchJars", queryalldata, withLoading);
    const startTime = Date.now();
    if (withLoading) {
      setLoading(true);
    }
    try {
      const lastUpdateParam = queryalldata === true
        ? "1970-01-01 00:00:00"
        : new Date(Date.now() - 5000).toISOString();
      const response = await fetchWithDeviceId(
        `${API_BASE}/api/jars?volume=${formData.quantity}&last_update=${encodeURIComponent(lastUpdateParam)}`
      );
      if (response.ok) {
        if (queryalldata === true) {
          const newJarData = await response.json();
          // 只有数据变化时才更新
          if (JSON.stringify(newJarData) !== JSON.stringify(jarList)) {
            setJarList(newJarData);
          }
        } else {
          const deltaData = await response.json(); // 返回的是变动数据
          if (deltaData && deltaData.length > 0) {
            setJarList(prevJarList => {
              // 用 Map 来快速更新或添加记录
              const jarMap = new Map(prevJarList.map(jar => [jar.id, jar]));
              let changed = false;
              // 更新或添加变动记录
              deltaData.forEach(updatedJar => {
                const oldJar = jarMap.get(updatedJar.id);
                // 只有在有实际变化时才更新
                if (!oldJar || JSON.stringify(oldJar) !== JSON.stringify(updatedJar)) {
                  jarMap.set(updatedJar.id, { ...oldJar, ...updatedJar });
                  changed = true;
                }
              });
              // 如果没有变化，返回原数组
              return changed ? Array.from(jarMap.values()) : prevJarList;
            });
          }
        }
      }
    } catch (error) {
      console.error('获取酒坛数据出错', error);
    } finally {
      if (withLoading) {
        const elapsed = Date.now() - startTime;
        if (elapsed < 300) {
          await delay(300 - elapsed);
        }
        setLoading(false);
      }
    }
  };

  /* useEffect(() => {
    async function resetSelectedJar() {
      if (selectedJar) {
        try {
          const payload = {
            previousJarId: selectedJar.id,
            newJarId: null,
            op_user: memberInfo ? memberInfo.tel : null,
          };
          const response = await fetchWithDeviceId(`${API_BASE}/api/jars/switchLock`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          });
          if (response.ok) {
            message.info(`已解锁 ${selectedJar.jar_name}`);
          } else {
            const errData = await response.json();
            message.error(errData.error || "解锁酒坛失败");
          }
        } catch (error) {
          message.error("解锁当前酒坛出错");
        }
      }
      // 清空选中状态
      setSelectedJar(null);
    }
    resetSelectedJar();
  }, [formData.jarHouse, formData.quantity]); */
  // 从 jarList 中提取唯一的酒阁选项
  // 独立处理 jarList 变化的 useEffect
  useEffect(() => {
    if (jarList.length > 0) {
      const houses = Array.from(new Set(jarList.map(jar => jar.jar_house)));
      setJarHouseOptions(houses);
      // 仅当当前没有选择酒阁时才自动设置第一个
      if (!formData.jarHouse && houses.length > 0) {
        const newJarHouse = houses[0];
        setFormData(prev => ({ ...prev, jarHouse: newJarHouse }));
        form.setFieldsValue({ jarHouse: newJarHouse });
      }
    } else {
      setJarHouseOptions([]);
      setFormData(prev => ({ ...prev, jarHouse: '' }));
      form.setFieldsValue({ jarHouse: '' });
    }
  }, [jarList, form]); // 添加 jarList 作为依赖

  // 当 jarList 更新时，同步更新购物车和选中状态
  useEffect(() => {
    // 同步购物车：如果某个购物车项对应的 jar 已经解锁，则移除该项
    if (shoppingCart.length > 0) {
      const updatedCart = shoppingCart.filter(item => {
        const jarInList = jarList.find(j => j.id === item.id);
        // 如果在 jarList 中找到对应的 jar 且 locked 为 1，则保持在购物车中；否则移除
        return jarInList ? jarInList.locked === 1 : true;
      });
      if (updatedCart.length !== shoppingCart.length) {
        setShoppingCart(updatedCart);
        message.info('购物车中的酒坛状态已更新，解锁的酒坛已移除');
      }
    }



  }, [jarList]);



  useEffect(() => {
    setSelectedJar(null);
  }, [formData.jarHouse]);

  // 当“藏酒容量”改变时，仅清空选中的酒坛，不再清空酒阁
  /*   useEffect(() => {
      setSelectedJar(null);
      // 保留原来的酒阁值，由 jarList 更新后自动赋值（如果当前为空）
    }, [formData.quantity]); */

  // 启动轮询更新酒坛数据
  useEffect(() => {
    if (currentStep === 0 && memberInfo && formData.quantity !== '') {
      fetchJars(true, true);
      pollingTimer.current = setInterval(() => {
        fetchJars(false, false);

      }, 1000);
    } else {
      if (pollingTimer.current) {
        clearInterval(pollingTimer.current);
        pollingTimer.current = null;
      }
    }
    return () => {
      if (pollingTimer.current) {
        clearInterval(pollingTimer.current);
        pollingTimer.current = null;
      }
    };
  }, [currentStep, memberInfo, formData.quantity]);

  /*   useEffect(() => {
      setSelectedJar(null);
      if (jarList.length > 0) {
        const houses = Array.from(new Set(jarList.map(jar => jar.jar_house)));
        if (houses.length > 0) {
          setFormData(prev => ({ ...prev, jarHouse: houses[0] }));
        }
      }
    }, [ formData.quantity ]);  */
  // 当“藏酒容量”改变时，清空选中状态

  useEffect(() => {
    console.info("formdata_qua change");
    setJarHouseOptions([]);
    setSelectedJar(null);
    // 清空当前的酒阁选择
    setFormData(prev => ({ ...prev, jarHouse: '' }));
    form.setFieldsValue({ jarHouse: '' });

    // 当 jarList 更新后会自动触发下面的 useEffect 来设置新酒阁
  }, [formData.quantity]);





  // 酒坛选择逻辑
  const handleJarSelect = (jar) => {
    // 如果当前点击的酒坛已经被选中，则取消选中
    if (selectedJar && selectedJar.id === jar.id) {
      setSelectedJar(null);
    } else {
      // 仅选中酒坛，不调用后端锁定接口
      setSelectedJar(jar);
    }
    /*  if (selectedJar && selectedJar.id === jar.id) {
      
         setSelectedJar(null);
       } else {
         // 仅选中酒坛，不调用后端锁定接口
         setSelectedJar(jar); */

    /* setLoading(true);
    const startTime = Date.now();
    try {
      const payload = {
        previousJarId: jar.id,
        newJarId: null,
        op_user: memberInfo ? memberInfo.tel : null
      };
      const response = await fetchWithDeviceId(`${API_BASE}/api/jars/switchLock`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        const errData = await response.json();
        message.error(errData.error || '取消选择时更新数据库失败');
      } else {
        setSelectedJar(null);
        setJarList(prevList =>
          prevList.map(item =>
            item.id === jar.id ? { ...item, locked: 0 } : item
          )
        );
        message.info(`已取消选择 ${jar.jar_name}`);
      }
    } catch (error) {
      message.error('取消选择出错');
    } finally {
      const elapsed = Date.now() - startTime;
      if (elapsed < 300) {
        await delay(300 - elapsed);
      }
      setLoading(false);
    } */
    //  return;
    // }
    // 如果该酒坛处于锁定状态且不是当前选中，则不响应
    /* if (jar.locked === 1 && (!selectedJar || selectedJar.id !== jar.id)) {
      return;
    }
    setLoading(true);
    const startTime = Date.now();
    try {
      const previousJarId = selectedJar ? selectedJar.id : null;
      const payload = {
        previousJarId: previousJarId,
        newJarId: jar.id,
        op_user: memberInfo ? memberInfo.tel : null
      };
      const response = await fetchWithDeviceId(`${API_BASE}/api/jars/switchLock`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        const errData = await response.json();
        message.error(errData.error || '更新酒坛状态失败');
      } else {
        const updatedJar = await response.json();
        setSelectedJar(updatedJar);
        setJarList(prevList =>
          prevList.map(item => {
            if (item.id === updatedJar.id) {
              return updatedJar;
            }
            if (previousJarId && item.id === previousJarId) {
              return { ...item, locked: 0 };
            }
            return item;
          })
        );
        message.success(`已选择 ${updatedJar.jar_name}`);
      }
    } catch (error) {
      message.error('更新酒坛状态出错');
    } finally {
      const elapsed = Date.now() - startTime;
      if (elapsed < 300) {
        await delay(300 - elapsed);
      }
      setLoading(false);
    } */
  };

  // 将当前选中的酒坛加入购物车
  const handleAddToCart = async () => {
    if (!selectedJar) {
      message.error('请先选择酒坛');
      return;
    }
    if (shoppingCart.find(item => item.id === selectedJar.id)) {
      message.info('该酒坛已加入购物车');
      return;
    }
    if (memberInfo.is_new) {
      if (!formData.ownerName) {
        message.error('请输入用户姓名');
        return;
      }
      if (!formData.agentName) {
        message.error('请输入经办人');
        return;
      }
    }
    setLoading(true);
    const startTime = Date.now();
    try {
      const payload = {
        previousJarId: null, // 此时没有之前的锁定
        newJarId: selectedJar.id,
        op_user: memberInfo ? memberInfo.tel : null,
      };
      const response = await fetchWithDeviceId(`${API_BASE}/api/jars/switchLock`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        const errData = await response.json();
        message.error(errData.error || '锁定酒坛失败');
      } else {
        const data = await response.json();
        if (!data.lock_success) {
          message.error('锁定失败，请稍后重试');
          return;
        }
        // 将当前选择的容量保存到酒坛数据中
        const updatedJarWithCapacity = { ...data, quantity: formData.quantity };
        // 锁定成功后更新购物车和 jarList 状态
        fetchJars(true, true);
        setShoppingCart(prev => [...prev, updatedJarWithCapacity]);
        setJarList(prevList =>
          prevList.map(item =>
            item.id === selectedJar.id ? { ...item, locked: 1 } : item
          )
        );
        message.success(`酒坛 ${selectedJar.jar_name} 已加入购物车`);
        setSelectedJar(null);
      }
    } catch (error) {
      console.error(error);
      message.error('锁定酒坛出错');
    } finally {
      const elapsed = Date.now() - startTime;
      if (elapsed < 300) {
        await delay(300 - elapsed);
      }
      setLoading(false);
    }
  };


  // 从购物车删除酒坛，同时调用接口解锁
  const handleDeleteCartItem = async (id) => {
    setLoading(true);
    const startTime = Date.now();
    try {
      const payload = {
        previousJarId: id,
        newJarId: null,
      };
      const response = await fetchWithDeviceId(`${API_BASE}/api/jars/switchLock`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        const errData = await response.json();
        message.error(errData.error || '解锁酒坛失败');
      } else {
        setShoppingCart(prev => prev.filter(item => item.id !== id));
        setJarList(prevList =>
          prevList.map(item =>
            item.id === id ? { ...item, locked: 0 } : item
          )
        );
        message.info('已解锁该酒坛并从购物车移除');
      }
    } catch (error) {
      message.error('解锁酒坛出错');
    } finally {
      const elapsed = Date.now() - startTime;
      if (elapsed < 300) {
        await delay(300 - elapsed);
      }
      setLoading(false);
    }
  };

  // 新增：重置购物车按钮处理函数，调用 reset 接口，释放所有购物车中的酒坛
  const handleReset = async () => {
    setLoading(true);
    try {
      const payload = {
        shoppingCart: shoppingCart

      };
      console.info("shoppingcart")
      console.info(shoppingCart)
      const response = await fetchWithDeviceId(`${API_BASE}/api/jars/reset`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      if (response.ok) {
        setShoppingCart([]);
        setJarList(prevList =>
          prevList.map(item => ({ ...item, locked: 0 }))
        );
        message.success("购物车已重置，所有酒坛已释放");
      } else {
        const errData = await response.json();
        message.error(errData.error || "重置失败");
      }
    } catch (error) {
      message.error("重置请求出错");
    } finally {
      setLoading(false);
    }
  };

  // 下一步按钮逻辑
  const nextStep = () => {
    if (!formData.phone && !memberInfo?.is_new) {
      message.error('请输入手机号');
      return;
    }
    if (!memberInfo) {
      message.error('请先查询到会员信息');
      return;
    }
    if (!formData.quantity) {
      message.error('请选择藏酒容量');
      return;
    }
    if (!formData.jarHouse) {
      message.error('请选择酒阁');
      return;
    }
    if (shoppingCart.length === 0) {
      message.error('请先选择酒坛并加入购物车');
      return;
    }
    if(memberInfo.is_new){
      if (!formData.ownerName) {
        message.error('请输入用户姓名');
        return;
      }
      if (!formData.agentName) {
        message.error('请输入经办人');
        return;
      }
    }
    /*  if (selectedJar && !shoppingCart.find(item => item.id === selectedJar.id)) {
       //setSelectedJar(null);
       setShoppingCart(prev => [...prev, selectedJar]);
       setJarList(prevList =>
         prevList.map(item => item.id === selectedJar.id ? { ...item, locked: 1 } : item)
       ); 
     } */
    setCurrentStep(1);
  };

  // 返回上一步
  const prevStep = () => {
    setCurrentStep(0);
  };
  const handleExpire = (jarId) => {
    // 将过期的酒坛移除购物车，并更新 jarList 状态（假设已自动解锁）
    fetchJars(true, true)
    setShoppingCart(prev => prev.filter(item => item.id !== jarId));
    setJarList(prevList =>
      prevList.map(item =>
        item.id === jarId ? { ...item, locked: 0 } : item
      )
    );
    message.info(`酒坛 ${jarId} 已自动解锁，已从购物车移除`);
  };
  const handleFormChange = (changedValues) => {
    setFormData({ ...formData, ...changedValues });
  };

  // 提交订单
  const handleSubmit = async () => {
    const orderPayload = {
      phone: formData.phone,
      quantity: formData.quantity,
      shoppingCart: shoppingCart,
      name: memberInfo ? memberInfo.name : '',
      nick_name: memberInfo ? memberInfo.nick_name : '',
      member_id: memberInfo ? memberInfo.id : -1,
      agent_name: formData?.agentName,
      owner_name: formData?.ownerName,
    };
    setLoading(true);
    const startTime = Date.now();
    try {
      const response = await fetchWithDeviceId(`${API_BASE}/api/order`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(orderPayload),
      });
      const result = await response.json();
      if (result.success) {
        setCurrentStep(2);
      } else {
        message.error('订单提交失败');
      }
    } catch (error) {
      message.error('提交订单出错');
    } finally {
      const elapsed = Date.now() - startTime;
      if (elapsed < 300) {
        await delay(300 - elapsed);
      }
      setLoading(false);
    }
  };

  // 倒计时效果
  useEffect(() => {
    let timer;
    if (currentStep === 2) {
      setCountdown(3);
      timer = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            clearInterval(timer);
            resetAll();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => {
      if (timer) clearInterval(timer);
    };
  }, [currentStep]);

  // 重置所有状态
  const resetAll = () => {
    setFormData({ phone: '', quantity: '', jarHouse: '' });
    setJarList([]);
    setMemberInfo(null);
    setJarHouseOptions([]);
    setShoppingCart([]);
    setSelectedJar(null);
    setCurrentStep(0);
  };
  const filteredJarList = useMemo(() => {
    return jarList.filter(jar => jar.jar_house === formData.jarHouse);
  }, [jarList, formData.jarHouse]);

  const validatePhone = (_, value) => {
    if(memberInfo?.is_new){
      return Promise.resolve();
    }
    if(!value){
      return Promise.reject(new Error('请输入手机号'));
    }
    return Promise.resolve();
  }
  // 根据当前步骤渲染不同视图
  const renderStepContent = () => {
    if (currentStep === 0) {
      return (
        <div>
          {/* 手机号输入与确认按钮 */}
          <div style={{ display: 'flex', gap: '8px', width: '100%', alignItems: 'center' }}>
            <Form
              layout="vertical"
              style={{ flex: 1 }}
              initialValues={{ phone: formData.phone }}
              onValuesChange={(changedValues) => handleFormChange(changedValues)}
            >
              <Form.Item label="手机号" name="phone" rules={[  { 
                                        validator: validatePhone 
                                    }]}>
                <Input size="large" placeholder="请输入手机号" />
              </Form.Item>
            </Form>
            <Button size="large" type="primary" onClick={handleConfirmPhone} style={{ flexShrink: 0 }}>
              确定
            </Button>
            <Button size="large"  onClick={()=>addUser({})} style={{ flexShrink: 0 }}>
              <span style={{ fontWeight: 'bold', fontSize: '22px' }}>+</span>新用户
            </Button>
          </div>
          {/* 会员信息卡片 */}
          {memberInfo && (
            <div style={{ width: '160px', margin: '16px auto', padding: '8px', border: '1px solid #eee', borderRadius: 4, textAlign: 'center' }}>
              <Text strong style={{ fontSize: '16px' }}>姓名：</Text>
              <Text style={{ fontSize: '16px' }}>{memberInfo.is_new ? "新会员" : memberInfo.name}</Text>
              <br />
              <Text strong style={{ fontSize: '16px' }}>昵称：</Text>
              <Text style={{ fontSize: '16px' }}>{memberInfo.is_new ? "新会员" : memberInfo.nick_name}</Text>
              <br />
              {!memberInfo.is_new && (
                <img src={memberInfo.head_img} alt="头像" style={{ width: 80, height: 80, borderRadius: '50%', marginTop: 8 }} />
              )}
            </div>
          )}
          {/* 购物车展示 */}
          {shoppingCart.length > 0 && (
            <div style={{ margin: '16px 0' }}>
              <Title level={4}>
                购物车
                {/* 在标题右侧放置重置按钮 */}
                <Button size="small" onClick={handleReset} style={{ marginLeft: 16 }}>
                  重置
                </Button>
              </Title>
              <Row gutter={[16, 16]}>
                {shoppingCart.map(item => (
                  <Col key={item.id}>
                    <CartItemCard
                      item={item}
                      onDelete={() => handleDeleteCartItem(item.id)}
                    />
                  </Col>
                ))}
              </Row>
            </div>
          )}
          {/* 藏酒容量选择 */}
          {memberInfo && (
            <Form
              layout="vertical"
              initialValues={{ quantity: formData.quantity, agentName: formData.agentName, ownerName: formData.ownerName }}
              onValuesChange={(changedValues) => handleFormChange(changedValues)}
            >
              {
                memberInfo.is_new && (
                  <>
                    <Form.Item label="用户姓名" name="ownerName" rules={[{ required: true, message: '请输入用户姓名' }]}>
                      <Input size="large" placeholder="请输入用户姓名" />
                    </Form.Item>
                    <Form.Item label="经办人" name="agentName" rules={[{ required: true, message: '请输入经办人' }]}>
                      <Input size="large" placeholder="请输入经办人" />
                    </Form.Item>
                  </>
                )
              }
              <Form.Item label="藏酒容量" name="quantity" rules={[{ required: true, message: '请选择藏酒容量' }]}>
                <Select size="large" placeholder="请选择藏酒容量">

                  <Option value="250L">250L</Option>
                  <Option value="500L">500L</Option>
                  <Option value="1000L">1000L</Option>
                </Select>
              </Form.Item>

            </Form>
          )}
          {/* 酒阁选择 */}
          {memberInfo && formData.quantity !== '' && jarHouseOptions.length > 0 && (
            <Form
              layout="vertical"
              initialValues={{ jarHouse: formData.jarHouse }}
              onValuesChange={(changedValues) => handleFormChange(changedValues)}
            >
              <Form.Item label="酒阁" name="jarHouse" rules={[{ required: true, message: '请选择酒阁' }]}>
                <Select size="large" placeholder="请选择酒阁">
                  {jarHouseOptions.map((house, index) => (
                    <Option key={index} value={house}>
                      {house}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Form>
          )}
          {/* 酒坛选择：使用新的 JarButton 组件 */}
          {memberInfo && formData.quantity !== '' && formData.jarHouse !== '' && (
            <div>
              {/* 固定头部区域 */}
              <div
                style={{
                  position: 'sticky',
                  top: 0,
                  zIndex: 100, // 保证在其他元素之上
                  background: '#fff', // 背景色要设置，否则可能出现透明问题
                  padding: '8px 16px',
                  borderBottom: '1px solid #f0f0f0',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}
              >
                <Title level={4}>选择酒坛 <Text style={{ fontSize: '12px', color: '#888' }}></Text></Title>
                <Button
                  size="large"
                  type="default"
                  onClick={handleAddToCart}
                  disabled={!(selectedJar && (memberInfo.is_new ? (formData.ownerName && formData.agentName) : true))} // 未选中酒坛时禁用
                >
                  加入购物车
                </Button>
              </div>
              <Row gutter={[16, 16]}>
                {filteredJarList.length > 0 ? (
                  filteredJarList.map((jar) => (
                    <Col key={jar.id}>
                      <JarButton
                        jar={jar}
                        onClick={handleJarSelect}
                        selected={selectedJar && selectedJar.id === jar.id}
                        myTel={memberInfo.tel}
                      />
                    </Col>
                  ))
                ) : (
                  <Text>没有可用的酒坛</Text>
                )}
              </Row>

            </div>
          )}
          {/* “加入购物车”按钮 */}
          {(selectedJar && (memberInfo.is_new ? (formData.ownerName && formData.agentName) : true)) && (
            <div style={{ marginTop: 24 }}>
              <Button size="large" type="default" onClick={handleAddToCart} style={{ marginRight: 8 }}>
                加入购物车
              </Button>
            </div>
          )}
        </div>
      );
    } else if (currentStep === 1) {
      // 确认页面：用户信息卡片和购物车内容
      return (
        <div style={{ padding: '32px' }}>
          <div style={{ marginBottom: '24px' }}>
            {memberInfo && <UserInfoCard memberInfo={memberInfo} phone={formData.phone} iptData={formData} />}
          </div>
          <div>
            <Title level={3}>订单预览

            </Title>
            {shoppingCart.length > 0 ? (
              <Row gutter={[16, 16]}>
                {shoppingCart.map(item => (
                  <Col key={item.id}>
                    <CartItemCard
                      item={item}
                      onDelete={() => handleDeleteCartItem(item.id)}
                    />
                  </Col>
                ))}
              </Row>
            ) : (
              <Text>购物车为空</Text>
            )}
          </div>
          <div style={{ marginTop: '24px', textAlign: 'center' }}>
            <Button size="large" type="primary" onClick={handleSubmit}>
              确定提交
            </Button>
          </div>
        </div>
      );
    } else if (currentStep === 2) {
      // 倒计时页面
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <div style={{
            padding: '32px',
            border: '1px solid #ddd',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            fontSize: '20px',
            textAlign: 'center'
          }}>
            <Title level={3}>订单提交成功</Title>
            <Text>页面将在 {countdown} 秒后返回首页</Text>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <Layout style={{ minHeight: '100vh', background: '#f0f2f5' }}>
      <Content style={{ padding: '40px 80px' }}>
        {/* 新增标题部分 */}
        <div style={{
          textAlign: 'center',
          marginBottom: 40,
          padding: '20px 0',
          backgroundColor: '#fff',
          borderRadius: 8,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
          <Title level={1} style={{
            color: '#1890ff',
            fontSize: '38px',
            margin: 0,
            textShadow: '2px 2px 4px rgba(0,0,0,0.1)'
          }}>
            神农架酱酒2025封藏节
          </Title>
          <Text strong style={{ fontSize: '18px', color: '#666' }}>
            酒坛封藏登记系统
          </Text>
          <div style={{ marginTop: 20 }}>
            <Button type="primary" onClick={() => window.location.reload()}>
              新的登记
            </Button>
          </div>
        </div>

        {currentStep !== 2 && (
          <Steps current={currentStep} style={{ marginBottom: 40, fontSize: '18px' }}>
            <Step title="填写信息" />
            <Step title="确认提交" />
          </Steps>
        )}
        <div style={{ background: '#fff', padding: 24, minHeight: 360 }}>
          <Spin spinning={loading}>
            {renderStepContent()}
          </Spin>
        </div>
      </Content>

      {/* 悬浮按钮部分保持不变 */}
      {currentStep === 0 && (
        <Button
          type="primary"
          disabled={!nextStepEnabled}
          onClick={nextStep}
          style={{
            position: 'fixed',
            right: '20px',
            top: '50%',
            transform: 'translateY(-50%)',
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            fontSize: '48px',
            backgroundColor: nextStepEnabled ? '#1890ff' : '#d9d9d9',
            borderColor: nextStepEnabled ? '#1890ff' : '#d9d9d9',
            zIndex: 1000,
          }}
        >
          <RightOutlined />
        </Button>
      )}
      {currentStep === 1 && (
        <Button
          type="primary"
          onClick={prevStep}
          style={{
            position: 'fixed',
            left: '20px',
            top: '50%',
            transform: 'translateY(-50%)',
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            fontSize: '48px',
            backgroundColor: '#1890ff',
            borderColor: '#1890ff',
            zIndex: 1000,
          }}
        >
          <LeftOutlined />
        </Button>
      )}
    </Layout>
  );
}

export default App;
